import { render, staticRenderFns } from "./dealInfo.vue?vue&type=template&id=661a8fe5&scoped=true&"
import script from "./dealInfo.vue?vue&type=script&lang=js&"
export * from "./dealInfo.vue?vue&type=script&lang=js&"
import style0 from "./dealInfo.vue?vue&type=style&index=0&id=661a8fe5&scoped=true&lang=css&"
import style1 from "./dealInfo.vue?vue&type=style&index=1&id=661a8fe5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661a8fe5",
  null
  
)

export default component.exports